import _reverseInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reverse";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import * as _ from "../../../util/lodash";
var Chart = createComponent({
  displayName: 'Chart',
  propTypes: {
    series: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.array
    })).isRequired,
    config: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    colors: PropTypes.array
  },
  defaultProps: {
    colors: ['#a3a3a3', '#345168', '#3ba7cc', '#eb8e1b', '#f6bd00']
  },
  lifecycles: {
    componentDidMount: function componentDidMount() {
      this.chart = drawChart(this.props);
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return nextProps.series !== this.props.series || nextProps.config !== this.props.config || nextProps.colors !== this.props.colors || nextProps.id !== this.props.id;
    },
    componentDidUpdate: function componentDidUpdate() {
      if (this.chart) this.chart.destroy();
      this.chart = drawChart(this.props);
    }
  },
  render: function render(p) {
    return /*#__PURE__*/React.createElement("div", {
      id: p.id
    });
  }
});

var drawChart = function drawChart(p) {
  var config = {
    credits: {
      enabled: false
    },
    series: p.series,
    chart: {
      renderTo: p.id
    },
    colors: p.colors,
    tooltip: {
      positioner: function positioner(labelWidth, labelHeight, point) {
        return {
          x: point.plotX - labelWidth / 2,
          y: point.plotY - labelHeight - 10
        };
      },
      followPointer: true,
      shadow: false,
      borderColor: '#D3D3D3',
      useHTML: true,
      shared: true,
      formatter: function formatter() {
        var points = this.points;

        if (this.points.length > 1) {
          var s = '<table>';

          _.each(_reverseInstanceProperty(points).call(points), function (point, i) {
            s += "<tr class=\"highcharts-tooltip__row\">\n                      <td class=\"highcharts-tooltip__bullet\"><span style=\"color:" + point.series.color + "\">\u25FC</span></td>\n                      <td class=\"highcharts-tooltip__name\">" + point.series.name + "</td>\n                      <td class=\"highcharts-tooltip__value\">" + point.y + "</td>\n                    </tr>";
          });

          return s + '</table>';
        } else {
          return 'No data to show';
        }
      }
    }
  };

  _.merge(config, p.config);

  return new Highcharts.Chart(config);
};

export default Chart;
//# sourceMappingURL=chart.js.map